document.addEventListener('DOMContentLoaded', function() {
    const progressTracker = document.getElementById('progress-tracker');
    const progressFill = document.getElementById('progress-fill');
    const levels = document.querySelectorAll('.level');
    const amountAwayElement = document.getElementById('amount-away');
    const closeTrackerButton = document.getElementById('close-tracker');

    function formatCurrency(value) {
        return value.toFixed(decimalPlaces);
    }

    function updateProgressTracker(data) {
        console.log('Updating progress tracker with data:', data);
        const totalPrice = data.total_price;
        const maxThreshold = Math.max(...data.levels.map(level => level.threshold));

        // Update progress bar with smooth animation
        const progressPercentage = Math.min((totalPrice / maxThreshold) * 100, 100);
        progressFill.style.transition = 'width 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)';
        progressFill.style.width = `${progressPercentage}%`;

        // Update amount away message with fade effect and typing animation
        fadeOutElement(amountAwayElement, () => {
            let message = '';
            if (data.amount_away > 0) {
                message = `You are ${data.currency_symbol}${formatCurrency(data.amount_away)} away from ${data.next_level}!`;
            } else {
                message = data.custom_messages.highest_level;
            }
            typeWriter(amountAwayElement, message, 0, 30);
        });

        // Update levels with animation
        data.levels.forEach((level, index) => {
            const levelElement = levels[index];
            const iconElement = levelElement.querySelector('.level-icon');
            
            if (level.reached) {
                if (!levelElement.classList.contains('reached')) {
                    levelElement.classList.add('reached');
                    animateLevelIcon(iconElement);
                }
            } else {
                levelElement.classList.remove('reached');
            }
            
            // Update threshold display with count-up animation
            const thresholdElement = levelElement.querySelector('.level-threshold');
            animateValue(thresholdElement, parseFloat(thresholdElement.textContent.replace(/[^0-9.-]+/g, "")), level.threshold, 1000);
        });

        // Show progress tracker with fade-in effect
        fadeInElement(progressTracker);
    }

    function fadeOutElement(element, callback) {
        element.style.opacity = '0';
        element.style.transform = 'translateY(-10px)';
        element.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        setTimeout(() => {
            if (callback) callback();
        }, 300);
    }

    function fadeInElement(element) {
        element.style.opacity = '0';
        element.style.transform = 'translateY(10px)';
        element.style.display = 'block';
        setTimeout(() => {
            element.style.opacity = '1';
            element.style.transform = 'translateY(0)';
            element.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        }, 50);
    }

    function animateLevelIcon(iconElement) {
        iconElement.style.transform = 'scale(1.2) rotate(360deg)';
        iconElement.style.transition = 'transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        setTimeout(() => {
            iconElement.style.transform = 'scale(1) rotate(0deg)';
        }, 500);
    }

    function typeWriter(element, text, index, speed) {
        if (index === 0) {
            element.textContent = '';
        }
        if (index < text.length) {
            element.textContent += text.charAt(index);
            setTimeout(() => typeWriter(element, text, index + 1, speed), speed);
        } else {
            fadeInElement(element);
        }
    }

    function animateValue(obj, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const currentValue = progress * (end - start) + start;
            obj.textContent = `${currencySymbol}${formatCurrency(currentValue)}`;
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    window.updateCart = function(price) {
        console.log('Updating cart with price:', price);
        const currentTotal = parseFloat(localStorage.getItem('cartTotal') || '0');
        const newTotal = currentTotal + price;
        localStorage.setItem('cartTotal', newTotal.toString());

        console.log('Sending POST request to /api/cart with total:', newTotal);
        fetch('/api/cart', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ total: newTotal }),
        })
        .then(response => {
            console.log('Received response from server:', response);
            return response.json();
        })
        .then(data => {
            console.log('Parsed data from server:', data);
            updateProgressTracker(data);
        })
        .catch(error => {
            console.error('Error updating cart:', error);
        });

        // Update cart total in the test interface
        const cartTotalElement = document.getElementById('cart-total');
        if (cartTotalElement) {
            cartTotalElement.textContent = `Cart Total: ${currencySymbol}${formatCurrency(newTotal)}`;
        }
    }

    closeTrackerButton.addEventListener('click', function() {
        fadeOutElement(progressTracker, () => {
            progressTracker.style.display = 'none';
        });
    });

    // Initial update
    const initialTotal = parseFloat(localStorage.getItem('cartTotal') || '0');
    console.log('Initial cart total:', initialTotal);
    fetch('/api/cart', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ total: initialTotal }),
    })
    .then(response => response.json())
    .then(data => {
        console.log('Initial data from server:', data);
        updateProgressTracker(data);
    })
    .catch(error => console.error('Error:', error));
});
